<template>
  <div
    class="fade page-sidebar-fixed page-header-fixed show page-container"
    v-if="authenticated || !pageOptions.pageEmpty"
    v-bind:class="{
      'page-sidebar-minified': pageOptions.pageSidebarMinified,
      'page-content-full-height': pageOptions.pageContentFullHeight,
      'page-without-sidebar': pageOptions.pageWithoutSidebar,
      'page-with-right-sidebar': pageOptions.pageWithRightSidebar,
      'page-with-two-sidebar': pageOptions.pageWithTwoSidebar,
      'page-with-wide-sidebar': pageOptions.pageWithWideSidebar,
      'page-with-light-sidebar': pageOptions.pageWithLightSidebar,
      'page-with-top-menu': pageOptions.pageWithTopMenu,
      'page-sidebar-toggled': pageOptions.pageMobileSidebarToggled,
      'page-right-sidebar-toggled':
        pageOptions.pageMobileRightSidebarToggled ||
        pageOptions.pageRightSidebarToggled,
      'has-scroll': pageOptions.pageBodyScrollTop
    }"
  >
    <Header />
    <TopMenu v-if="pageOptions.pageWithTopMenu" />
    <Sidebar v-if="!pageOptions.pageWithoutSidebar" />
    <SidebarRight v-if="pageOptions.pageWithTwoSidebar" />
    <div
      id="content"
      class="content"
      v-bind:class="{
        'content-full-width': pageOptions.pageContentFullWidth,
        'content-inverse-mode': pageOptions.pageContentInverseMode
      }"
    >
      <router-view></router-view>
      <vue-ins-progress-bar></vue-ins-progress-bar>
    </div>
    <Footer v-if="pageOptions.pageWithFooter" />
    <dialogs-wrapper tag="div" />
    <ts-lock-screen v-show="isLock" @reset="resetTimer"></ts-lock-screen>
  </div>
  <div v-else-if="authenticated && pageOptions.pageEmpty">
    <router-view></router-view>
    <vue-ins-progress-bar></vue-ins-progress-bar>
    <ts-lock-screen v-show="isLock" @reset="resetTimer"></ts-lock-screen>
  </div>
  <div v-else>
    <router-view></router-view>
    <vue-ins-progress-bar></vue-ins-progress-bar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Sidebar from './components/sidebar/Sidebar.vue'
import SidebarRight from './components/sidebar-right/SidebarRight.vue'
import Header from './components/header/Header.vue'
import TopMenu from './components/top-menu/TopMenu.vue'
import Footer from './components/footer/Footer.vue'
import PageOptions from './config/PageOptions.vue'

export default {
  name: 'app',
  components: {
    Sidebar,
    SidebarRight,
    Header,
    TopMenu,
    Footer
  },
  data () {
    return {
      pageOptions: PageOptions,
      lock: false,
      lockTimer: null,
      events: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'load']
    }
  },
  computed: {
    ...mapGetters(['authenticated']),
    isLock () {
      if (this.$route.name == 'pickup-display') {
        return false
      }
      return this.$store.state.isLockScreen
    },
    company () {
      if (this.$store.state.authUser) {
        return this.$store.state.authUser.company
      }
      return null
    }
  },
  methods: {
    handleIcon () {
      // accessing the link tag
      const favicon = document.getElementById('favicon')
      const title = document.getElementById('title')
      title.innerHTML = this.company.company_name_en
      favicon.href = this.company.favicon
    },
    handleScroll: function () {
      PageOptions.pageBodyScrollTop = window.scrollY
    },
    setTimer () {
      if (this.authenticated) {
        this.lockTimer = setTimeout(() => {
          this.$store.commit('setIsLock', 1)
          localStorage.setItem('!z_dy#@_____00111$%!@', 1)
        }, 300 * 10000)
      }
    },
    resetTimer () {
      clearTimeout(this.lockTimer)
      this.setTimer()
    },
    switchUserType () {
      this.$store
        .dispatch('user/changeUserType')
        .then(response => {
          const authUser = JSON.parse(localStorage.getItem('authUser'))
          if (authUser) {
            this.$store.commit('setAuthUser', {
              user_name: authUser.user_name,
              full_name: authUser.full_name,
              access_token: authUser.access_token,
              permission_allow_code: authUser.permission_allow_code,
              user_type: authUser.user_type,
              guardian_type_id: authUser.guardian_type_id,
              permissions: authUser.permissions,
              default_branch: authUser.default_branch,
              default_branch_id: authUser.default_branch_id,
              user_profile: authUser.user_profile,
              cashier_location_id: authUser.cashier_location_id,
              children: authUser.children,
              company: authUser.company,
              is_external: response.is_external //set is_external user type by response
            })
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    }
  },
  mounted () {
    this.$insProgress.finish()
    this.events.forEach(event => {
      window.addEventListener(event, this.resetTimer)
    })

    this.setTimer()
    if (this.company) {
      this.handleIcon()
    }
  },
  created () {
    PageOptions.pageBodyScrollTop = window.scrollY

    window.addEventListener('scroll', this.handleScroll)

    this.$insProgress.start()

    this.$router.beforeEach((to, from, next) => {
      this.$insProgress.start()
      next()
    })
    this.$router.afterEach(() => {
      this.$insProgress.finish()
    })
    //remove modal iview bcus conflict with modal js
    this.$Modal.remove()
    
    this.$Notice.config({
      top: 50,
      duration: 5
    })
    this.$Message.config({
      top: 50,
      duration: 5
    })
    
    //switch user type (is_external = true/false)
    window.addEventListener('keydown', e => {
      if (e.shiftKey && e.keyCode == 113) {
        const authUser = JSON.parse(localStorage.getItem('authUser'))
        if(authUser){
          this.switchUserType()
        }
      }
    })
  }
}
</script>
